import { render, staticRenderFns } from "./AssinaturasList.vue?vue&type=template&id=621976a6"
import script from "./AssinaturasList.vue?vue&type=script&lang=js"
export * from "./AssinaturasList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports